var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEnrichEmailsPhone = function SvgEnrichEmailsPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.75,
    y: 0.75,
    width: 12.5,
    height: 9.5,
    rx: 1.25,
    fill: "white",
    stroke: "#FEAC2D",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2L16 5L22 2",
    stroke: "#FEAC2D",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14379 5.82353C1.96859 5.82353 1.82353 5.96859 1.82353 6.14379C1.82353 12.7901 7.2099 18.1765 13.8562 18.1765C14.0314 18.1765 14.1765 18.0314 14.1765 17.8562V15.3014C14.1765 15.1262 14.0314 14.9812 13.8562 14.9812C12.9045 14.9812 11.9752 14.8277 11.1137 14.5431L11.1093 14.5417C11.0023 14.505 10.8742 14.5322 10.7874 14.619L8.5 17L8.23309 16.8633C6.08529 15.7628 4.22953 13.7565 3.13559 11.6066L3 11.3401L5.38101 9.21264C5.47214 9.12148 5.49857 8.99856 5.46304 8.88286C5.17925 8.02256 5.02615 7.10173 5.02615 6.14379C5.02615 5.96859 4.88109 5.82353 4.70588 5.82353H2.14379ZM1 6.14379C1 5.51377 1.51377 5 2.14379 5H4.70588C5.33592 5 5.84968 5.51377 5.84968 6.14379C5.84968 7.01464 5.98898 7.84949 6.24613 8.62798L6.24708 8.63082L6.24798 8.63366C6.37246 9.02974 6.2815 9.47675 5.96333 9.79496L3.13559 12.3889C4.10954 14.1752 6.08068 15.6038 7.86926 16.5841L10.205 14.0367C10.5129 13.7288 10.9691 13.6241 11.374 13.7618C12.1517 14.0185 12.9932 14.1576 13.8562 14.1576C14.4862 14.1576 15 14.6714 15 15.3014V17.8562C15 18.4862 14.4862 19 13.8562 19C6.75507 19 1 13.2449 1 6.14379Z",
    fill: "#FEAC2D",
    stroke: "#FEAC2D",
    strokeWidth: 0.6
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnrichEmailsPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/enrichEmailsPhone.f1ff9455.svg";
export { ForwardRef as ReactComponent };